// extracted by mini-css-extract-plugin
export var collapsedSummary = "_lz-0";